/**
 * Runs a task once the browser is idle, and returns a function cancelling it if
 * it has not run yet.
 *
 * `requestIdleCallback` is still missing from older WebKit, which the Capacitor
 * builds run on, so this falls back to a plain timeout there. Both paths are
 * bounded: the task always runs, at the latest after `timeout` ms, so a busy
 * main thread can never postpone it forever.
 */
export function runWhenIdle(task: () => void, timeout = 2000): () => void {
  if (typeof requestIdleCallback === 'function') {
    const handle = requestIdleCallback(task, { timeout });
    return () => cancelIdleCallback(handle);
  }

  const handle = setTimeout(task, timeout);
  return () => clearTimeout(handle);
}
